import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import { Typography } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  title: {
    margin: "8px 0",
    fontWeight: "bold",
    fontSize: "18px",
  },
  contents: {
    overflow: "hidden",
    transition: "height 0.3s ease-in-out, margin-bottom 0.3s ease-in-out",
  },
};

function SlideDown({ children, title }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight); // Get the natural height
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  const toggleSlide = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div>
      <div style={styles.header} onClick={toggleSlide}>
        <IconButton aria-label="expand" size="small" sx={{ padding: 0 }}>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
        <Typography sx={styles.title}>{title}</Typography>
      </div>
      <div style={{ ...styles.contents, height, marginBottom: isOpen ? "10px" : "0px" }}>
        <div ref={contentRef}>{children}</div>
      </div>
    </div>
  );
}
SlideDown.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default SlideDown;
